document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.collection-hero__slider');
  const slides = slider?.children || [];
  const dots = document.querySelectorAll('.collection-hero__slider-dot');
  if (!slider || slides.length <= 1 || dots.length === 0) return;

  let activeIndex = 0;

  const updateDots = (index) => {
    dots.forEach((dot) => dot.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');
  };

  updateDots(activeIndex);

  slider.addEventListener('scroll', () => {
    const scrollLeft = slider.scrollLeft;
    const slideWidth = slider.offsetWidth;
    const index = Math.round(scrollLeft / slideWidth);
    if (index !== activeIndex) {
      activeIndex = index;
      updateDots(index);
    }
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.index);
      slider.scrollTo({ left: index * slider.offsetWidth, behavior: 'smooth' });
      updateDots(index);
    });
  });
});
